<script setup lang="ts">
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'

export interface GatSwitchProps {
  /** The label of the switch. If not provided, the switch will not have a label. */
  label?: string
  /** The position of the label.
   * @default 'left'
   */
  labelPosition?: 'left' | 'right'
  /** The background color of the switch when the model is true.
   * @default 'bg-primary'
   */
  trueBgColor?: string
  /** The background color of the switch when the model is false.
   * @default 'bg-background-secondary'
   */
  falseBgColor?: string
  /** Whether the switch is disabled.
   * @default false
   */
  disabled?: boolean
}

const props = withDefaults(defineProps<GatSwitchProps>(), {
  trueBgColor: 'bg-primary',
  falseBgColor: 'bg-neutral-200',
  labelPosition: 'left',
  disabled: false
})

const model = defineModel({
  default: false
})
</script>
<template>
  <SwitchGroup as="div" class="flex items-center">
    <template v-if="labelPosition === 'left'">
      <slot name="label">
        <SwitchLabel as="span" class="mr-3 text-xs">
          <span class="text-foreground font-medium">{{ label }}</span>
        </SwitchLabel>
      </slot>
    </template>
    <Switch v-model="model" :disabled="disabled" :class="[
      model ? props.trueBgColor : props.falseBgColor,
      'focus:ring-primary relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2'
    ]">
      <span aria-hidden="true" :class="[
        model ? 'translate-x-5' : 'translate-x-0',
        'pointer-events-none inline-block h-5 w-5 transform rounded-full shadow ring-0 transition duration-200 ease-in-out'
      ]" style="background-color: white" />
    </Switch>
    <template v-if="labelPosition === 'right'">
      <slot name="label">
        <SwitchLabel as="span" class="ml-3 text-xs">
          <span class="text-foreground font-medium">{{ label }}</span>
        </SwitchLabel>
      </slot>
    </template>
  </SwitchGroup>
</template>
